export const selectMonitoreosEventosState = (state) => state.monitoreosEventos;

export const selectMonitoreosEventosFormState = (state) => state.monitoreosEventos.form;
